export function adjustMasthead() {
  const masthead = document.querySelector('.site-masthead--main');
  const mastheadInnerContainer = document.querySelector('.site-masthead__inner');
  const mastheadInner = document.querySelector('.site-masthead__inner-details');
  const siteHeader = document.querySelector('.site-header');

  function adjustMastheadHeight() {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const siteHeaderHeight = siteHeader.offsetHeight;
      var mastheadContentHeight = mastheadInner.offsetHeight + (siteHeaderHeight * 2);
      
      if (windowHeight > mastheadContentHeight && windowWidth > 500) {

          masthead.style.height = '100vh';
          mastheadInnerContainer.style.position = 'absolute';
          mastheadInnerContainer.style.padding = 'var(--padding-header-height) 0';
          masthead.style.paddingTop = siteHeaderHeight + 'px';
          masthead.style.paddingBottom = '150px'; // Adjust as needed
      } else if(windowWidth > 500 ) {
    
          masthead.style.height = 'auto';
          mastheadInnerContainer.style.position = 'relative'
          
          mastheadInnerContainer.style.paddingTop = '65px';
          mastheadInnerContainer.style.paddingBottom = '15px';
      } else {
    
        masthead.style.height = 'auto';
        mastheadInnerContainer.style.position = 'relative'
        
        mastheadInnerContainer.style.padding = '25px 0';
    }

  }
  adjustMastheadHeight();

}
